import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CopyToClipboardDirective } from 'src/app/core/directives/copy-to-clipboard.directive';

import { SharePipesModule } from '../../../core/pipes/pipes.module';
import { TranslationModule } from '../../../i18n/translation.module';
import { MaterialModule } from '../../modules/material/material.module';
import { ListGroupItemComponent } from './list-group-item.component';

@NgModule({
  declarations: [
    ListGroupItemComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    TranslationModule,
    SharePipesModule,
    CopyToClipboardDirective
  ],
  exports: [
    ListGroupItemComponent
  ],

})
export class ListGroupItemModule { }
